function iWishCounter() {
	try {
		if (typeof iWish !== 'undefined') {
			if (iWish.getCounter() <= 0) {
				document.querySelectorAll(".iw-count-show").forEach((elm) => {
					elm.style.display = 'none';
				})
			}
			else {
				document.querySelectorAll(".iw-count-show").forEach((elm) => {
					elm.style.display = 'inline-block';
				})
			}
		}
	}
	catch (error) {
		//console.log(error);
	}
}

function iWishRemoveFn(vId) {
	try {
		iWishCounter();
	}
	catch (error) {
		//console.log(error);
	}
}
function iWishAddFn(vId) {
	try {
		iWishCounter();
	}
	catch (error) {
		//console.log(error);
	}
}
function iWishinitFn() {
	try {
		window.iWishData.money_format = Shopify.money_format + " " + Shopify.currency.active;
		iWishCounter();
	}
	catch (error) {
		//console.log(error);
	}
}
function addToCartInitCallback(vId, pId, catId) {
	try {
		if (document.querySelector('.header-cart-number').classList.contains('hide-m')) {
			document.querySelector('.header-cart-number').classList.remove('hide-m');
		}
	}
	catch (error) {
		// console.log(error);
	}
}
function addAllToCartInitCallback(iwCart_data) {
	try {
		if (document.querySelector('.header-cart-number').classList.contains('hide-m')) {
			document.querySelector('.header-cart-number').classList.remove('hide-m');
		}
	}
	catch (error) {
		// console.log(error);
	}
}